import styled from 'styled-components';
import { Button } from '../../../../../../components/Toolkit/Button/Button';
import { media } from 'helpers/breakpoints';

export const SavedSearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.M16};

  ${media.medium} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

export const IconAndTextContainer = styled.div`
  display: flex;
  flex-flow: column;
`;

export const SButton = styled(Button)`
  flex: 1 0 auto;

  ${media.medium} {
    max-width: 288px;
  }
`;

export const Header = styled.p`
  ${({ theme }) => theme.fontSize.M16};
  color: ${({ theme }) => theme.colors.GREY_DARKER};
  font-weight: ${({ theme }) => theme.fontWeight.bold};

  ${media.medium} {
    ${({ theme }) => theme.fontSize.L18};
  }
`;

export const Subtitle = styled.p`
  ${({ theme }) => theme.fontSize.M14};
  color: ${({ theme }) => theme.colors.GREY_DARK};
  display: none;

  ${media.large} {
    display: block;
  }
`;
